import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getDocumentStandardWorkflows,
  updateActiveDocument
} from '../../../api/documents';
import { getWorkflowStepWithPositions } from '../../../api/workflow-steps';
import { Document } from '../Document/documentSlice';
import { ProjectPositionWorkflowStep } from '../ProjectPositionWorkflowStep/projectPositionWorkflowStepSlice';
import { WorkflowStep } from '../WorkflowStep/workflowStepSlice';
import {
  createDocumentProjectPositionWorkflowStep,
  deleteDocumentProjectPositionWorkflowStep
} from '../../../api/document-project-position-workflow-steps';

export const getDocumentStandardWorkflowsAsync = createAsyncThunk(
  'standardWorkflows/getDocumentStandardWorkflows',
  getDocumentStandardWorkflows
);

export const getWorkflowStepWithPositionsAsync = createAsyncThunk(
  'standardWorkflows/getWorkflowStepWithPositions',
  getWorkflowStepWithPositions
);

export const createDocumentProjectPositionWorkflowStepAsync = createAsyncThunk(
  'standardWorkflows/createDocumentProjectPositionWorkflowStep',
  createDocumentProjectPositionWorkflowStep
);

export const deleteDocumentProjectPositionWorkflowStepAsync = createAsyncThunk(
  'standardWorkflows/deleteDocumentProjectPositionWorkflowStep',
  deleteDocumentProjectPositionWorkflowStep
);

export const updateActiveDocumentAsync = createAsyncThunk(
  'standardWorkflows/updateActiveDocument',
  updateActiveDocument
);

interface Header extends WorkflowStep {
  projectPositionWorkflowSteps: ProjectPositionWorkflowStep[];
}

interface DocumentStandardWorkflow extends Document {
  projectPositionWorkflowSteps: ProjectPositionWorkflowStep[];
}

interface StandardWorkflowState {
  headers: Header[];
  data: DocumentStandardWorkflow[];
  count: number;
}

const initialState: StandardWorkflowState = {
  headers: [],
  data: [],
  count: 0
};

export default createSlice({
  name: 'standardWorkflows',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getDocumentStandardWorkflowsAsync.fulfilled,
      (state, action) => {
        state.data = action.payload.data;
        state.count = action.payload.count;
      }
    );
    builder.addCase(
      getWorkflowStepWithPositionsAsync.fulfilled,
      (state, action) => {
        state.headers = action.payload.data;
      }
    );
    builder.addCase(updateActiveDocumentAsync.fulfilled, (state, action) => {
      const updatedDocument = action.payload;
      const indexOfDocument =
        state.data.findIndex(
          (document) => document.id === updatedDocument.id
        ) ?? -1;
      if (indexOfDocument >= 0) {
        const newDocument = {
          ...state.data[indexOfDocument],
          isActive: updatedDocument.isActive
        };
        const newDocuments = [
          ...state.data.slice(0, indexOfDocument),
          newDocument,
          ...state.data.slice(indexOfDocument + 1)
        ];
        state.data = newDocuments;
      }
    });
  }
});
